import { useCallback } from "react";
import { FileInputArea } from "@rapid/components/flow/shared/FileInputArea";
import { ModalWithIcon } from "@scripts/react/components/RfModal/ModalWithIcon";
import { MediaItem } from "@rapid/types/media";
import { useMedia } from "@rapid/contexts/MediaContext";
import { UploadLimitErrorType } from "@rapid/constants/media";
import { UploadLimitHint } from "@rapid/components/flow/build/Hints/UploadLimitHint";

const Modal = ModalWithIcon as any;

interface FileUploadModalProps {
    isModalOpen: boolean;
    setIsModalOpen: (isOpen: boolean) => void;
    onAddMediaItems: (files: File[]) => void;
    title: string;
    erroredMediaItems?: MediaItem[];
    uploadLimitError?: UploadLimitErrorType | null;
}

export const FileUploadModal = ({
    isModalOpen,
    setIsModalOpen,
    onAddMediaItems,
    title,
    erroredMediaItems = [],
    uploadLimitError: uploadLimitErrorProp
}: FileUploadModalProps) => {
    const { clearUploadLimitError } = useMedia();

    const handleClose = useCallback(() => {
        clearUploadLimitError();
        setIsModalOpen(false);
    }, [clearUploadLimitError, setIsModalOpen]);

    return (
        <Modal
            isOpen={isModalOpen}
            onClose={handleClose}
            type="info"
            size="xl"
            icon="fad fa-upload"
            title={title}
            showFooter={false}
        >
            <div className="flex flex-col items-center gap-4">
                <UploadLimitHint
                    uploadLimitError={uploadLimitErrorProp ?? null}
                    onUploadAgain={clearUploadLimitError}
                    onDismiss={clearUploadLimitError}
                />
                <FileInputArea
                    addMediaItems={onAddMediaItems}
                    erroredMediaItems={erroredMediaItems}
                    qrSize={90}
                    showAllMethods={true}
                    uploadLimitError={uploadLimitErrorProp}
                />
            </div>
        </Modal>
    );
};
